/* eslint-disable import/no-unresolved */
import React from 'react';

import performanceSVG from 'assets/resources/icon/performance.svg';
import securitySVG from 'assets/resources/icon/security.svg';
import infrastructureSVG from 'assets/resources/icon/infrastructure_costs.svg';

import ImgHTML from '../../ImgHTML';

const IconsSection = () => {
  return (
    <div className="icon-beam">
      <div className="subtitle-simple">Check it with us</div>
      <div className="row">
        <div className="col-md-4">
          <div className="single-item">
            <div className="icon">
              <ImgHTML src={performanceSVG} alt="performance" />
            </div>
            <div className="content">
              <div className="tt">Performance</div>
              <div className="dd">
                <p>
                  Run a proper performance test with us. Do it before clients
                  turn away from your application or give critical feedback.
                  During the test, we will verify the stability, scalability,
                  responsiveness, reliability and speed of your software.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="single-item">
            <div className="icon">
              <ImgHTML src={securitySVG} alt="security" />
            </div>
            <div className="content">
              <div className="tt">Security</div>
              <div className="dd">
                <p>
                  We’ve implemented the best security methods for our clients,
                  from manufacturing to financial platforms. You can get our
                  expertise and advice in the field.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="single-item">
            <div className="icon">
              <ImgHTML src={infrastructureSVG} alt="infrastructure" />
            </div>
            <div className="content">
              <div className="tt">Infrastructure costs</div>
              <div className="dd">
                <p>
                  Our Clients have saved up to 66% of their infrastructure
                  costs. Let us analyze your structure, then praise it or give
                  our recommendations on how to improve it.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IconsSection;
